export default function getFadeposAnimation (element, settings) {
    const fadepos = {
        opacity: 0,
        y: 0,
        x: 0
    }

    //Set the position properties based on the startposition
    if( settings.start_position ){
        // set y position
        if( settings.start_position.indexOf("top") > -1 ){
            fadepos.y =  "-="+settings.startoffset+"em";
        }else if( settings.start_position.indexOf("bottom") > -1 ){
            fadepos.y = "+="+settings.startoffset+"em";
        }
        // set x position
        if( settings.start_position.indexOf("left") > -1 ){
            fadepos.x = "-="+settings.startoffset+"em";
        }else if( settings.start_position.indexOf("right") > -1 ){
            fadepos.x = "+="+settings.startoffset+"em";
        }
    }
    return fadepos;
}
